(function () {
  'use strict';

  var STORAGE_PREFIX = 'COLLECTION_STATE:';
  var DEFAULT_OFFSET = 500;
  var MAX_RESTORE_AGE = 10 * 60 * 1000;
  var isLoadingNext = false;
  var isLoadingPrev = false;
  var isReplacingGrid = false;
  var observerStarted = false;
  var mutationObserver = null;

  // חוסם את onScroll בזמן restore כדי למנוע טעינת עמודים נוספים
  var isRestoring = false;

  // ─── עזרי DOM ─────────────────────────────────────────────────────────────────

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\#.;?+*~':!^$[\]()=>|/@]/g, '\\$&');
  }

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getGridContainer() {
    return document.getElementById('ProductGridContainer');
  }

  function getPrevWrapper() {
    return document.getElementById('collection-prev-page-wrapper');
  }

  // ─── data-* getters/setters ───────────────────────────────────────────────────

  function isEnabled() {
    var grid = getGrid();
    return !!(grid && grid.dataset.infiniteEnabled === 'true');
  }

  function getSectionId() {
    var grid = getGrid();
    if (!grid) return '';
    return grid.dataset.sectionId || grid.dataset.id || '';
  }

  function getOffset() {
    var grid = getGrid();
    if (!grid) return DEFAULT_OFFSET;
    var parsed = parseInt(grid.dataset.infiniteOffset || DEFAULT_OFFSET, 10);
    return Number.isFinite(parsed) ? parsed : DEFAULT_OFFSET;
  }

  function getCurrentPage() {
    var grid = getGrid();
    if (!grid) return 1;
    var parsed = parseInt(grid.dataset.currentPage || '1', 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  }

  function setCurrentPage(page) {
    var grid = getGrid();
    if (!grid) return;
    grid.dataset.currentPage = String(page);
  }

  function getNextUrl() {
    var grid = getGrid();
    if (!grid) return '';
    return grid.dataset.nextUrl || '';
  }

  function setNextUrl(url) {
    var grid = getGrid();
    if (!grid) return;
    grid.dataset.nextUrl = url || '';
  }

  function getPrevUrl() {
    var grid = getGrid();
    if (!grid) return '';
    return grid.dataset.prevUrl || '';
  }

  function setPrevUrl(url) {
    var grid = getGrid();
    if (!grid) return;
    grid.dataset.prevUrl = url || '';
  }

  // ─── לודר ────────────────────────────────────────────────────────────────────

  function getLoader() {
    return document.getElementById('collection-infinite-loader');
  }

  function showLoader(show) {
    var loader = getLoader();
    if (!loader) return;
    loader.classList.toggle('is-visible', !!show);
  }

  // ─── כפתור "עמוד קודם" ───────────────────────────────────────────────────────

  function injectPrevButton() {
    if (getPrevWrapper()) return;

    var container = getGridContainer();
    if (!container) return;

    var grid = getGrid();
    var label = (grid && grid.dataset.prevLabel) || 'טען עמוד קודם';

    var wrapper = document.createElement('div');
    wrapper.id = 'collection-prev-page-wrapper';
    wrapper.style.cssText = 'text-align:center; padding:12px 0 8px;';

    var btn = document.createElement('button');
    btn.id = 'collection-prev-page-btn';
    btn.type = 'button';
    btn.className = 'button';
    btn.textContent = label;
    btn.addEventListener('click', function () {
      prependPrevPage();
    });

    wrapper.appendChild(btn);
    container.insertBefore(wrapper, container.firstChild);
  }

  function removePrevButton() {
    var wrapper = getPrevWrapper();
    if (wrapper) wrapper.parentNode.removeChild(wrapper);
  }

  function setPrevBtnDisabled(disabled) {
    var wrapper = getPrevWrapper();
    if (!wrapper) return;
    var btn = wrapper.querySelector('button');
    if (btn) btn.disabled = disabled;
  }

  // ─── URL helpers ──────────────────────────────────────────────────────────────

  function normalizeUrlKey(urlString) {
    try {
      var url = new URL(urlString || window.location.href, window.location.origin);
      url.searchParams.delete('page');
      var query = url.searchParams.toString();
      return url.pathname + (query ? '?' + query : '');
    } catch (e) {
      return window.location.pathname;
    }
  }

  function getStorageKey() {
    return STORAGE_PREFIX + normalizeUrlKey(window.location.href);
  }

  function getPageFromUrl(urlString) {
    try {
      var url = new URL(urlString, window.location.origin);
      var parsed = parseInt(url.searchParams.get('page') || '1', 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    } catch (e) {
      return 1;
    }
  }

  // ── סנכרון מטא-דאטה לפי עמוד (קנוניקל, טייטל, דסקריפשן, og, H1) ──

  // נלכד פעם אחת בטעינה, לפני שמשנים כלום — אלה ערכי "הבסיס" הנקיים
  var META_BASE = (function () {
    var titleEl = document.querySelector('title');
    var descEl = document.querySelector('meta[name="description"]');
    var ogTitleEl = document.querySelector('meta[property="og:title"]');
    var ogDescEl = document.querySelector('meta[property="og:description"]');
    var ogUrlEl = document.querySelector('meta[property="og:url"]');
    var h1El = document.querySelector('.collection-hero__title');

    function stripSuffix(text) {
      if (!text) return '';
      // מסיר " – עמוד N" או " - Page N" אם כבר קיים מהשרת
      return text.replace(/\s*[–-]\s*(?:עמוד|Page)\s*\d+/i, '').trim();
    }

    function h1Text(el) {
      if (!el) return '';
      // טקסט הכותרת בלי ה-span של הסיומת
      var first = el.childNodes[0];
      var raw = (first && first.nodeType === 3) ? first.nodeValue : el.textContent;
      return stripSuffix((raw || '').trim());
    }

    return {
      titleEl: titleEl,
      descEl: descEl,
      ogTitleEl: ogTitleEl,
      ogDescEl: ogDescEl,
      ogUrlEl: ogUrlEl,
      h1El: h1El,
      titleClean: titleEl ? stripSuffix(titleEl.textContent.trim()) : '',
      descClean: descEl ? stripSuffix(descEl.getAttribute('content') || '') : '',
      ogTitleClean: ogTitleEl ? stripSuffix(ogTitleEl.getAttribute('content') || '') : '',
      ogDescClean: ogDescEl ? stripSuffix(ogDescEl.getAttribute('content') || '') : '',
      h1Clean: h1Text(h1El)
    };
  })();

  function cleanBaseUrl() {
    return window.location.origin + window.location.pathname;
  }

  // מכניס " – עמוד N" אחרי השם, לפני " – אליטל" אם קיים
  function insertTitleSuffix(text, page) {
    if (!text || page <= 1) return text;
    var parts = text.split(' – ');
    if (parts.length > 1) {
      var shopName = parts.pop();
      return parts.join(' – ') + ' – עמוד ' + page + ' – ' + shopName;
    }
    return text + ' – עמוד ' + page;
  }

  function updateCanonicalForPage(page) {
    var link = document.querySelector('link[rel="canonical"]');
    if (!link) return;
    var base = cleanBaseUrl();
    var desired = page > 1 ? base + '?page=' + page : base;
    if (link.getAttribute('href') !== desired) {
      link.setAttribute('href', desired);
    }
  }

  function updateMetaForPage(page) {
    var m = META_BASE;

    // טייטל
    if (m.titleEl && m.titleClean) {
      m.titleEl.textContent = insertTitleSuffix(m.titleClean, page);
    }

    // דסקריפשן
    if (m.descEl && m.descClean) {
      m.descEl.setAttribute('content', page > 1 ? m.descClean + ' – עמוד ' + page : m.descClean);
    }

    // og:title
    if (m.ogTitleEl && m.ogTitleClean) {
      m.ogTitleEl.setAttribute('content', page > 1 ? m.ogTitleClean + ' – עמוד ' + page : m.ogTitleClean);
    }

    // og:description
    if (m.ogDescEl && m.ogDescClean) {
      m.ogDescEl.setAttribute('content', page > 1 ? m.ogDescClean + ' – עמוד ' + page : m.ogDescClean);
    }

    // og:url – עוקב אחרי הקנוניקל
    if (m.ogUrlEl) {
      var base = cleanBaseUrl();
      m.ogUrlEl.setAttribute('content', page > 1 ? base + '?page=' + page : base);
    }

    // H1 – מעדכנים רק את צומת הטקסט הראשון + span הסיומת, בלי לדרוס תוכן אחר
    if (m.h1El && m.h1Clean) {
      var suffixSpan = m.h1El.querySelector('.collection-hero__page-suffix');
      if (m.h1El.childNodes[0] && m.h1El.childNodes[0].nodeType === 3) {
        m.h1El.childNodes[0].nodeValue = m.h1Clean;
      }
      if (page > 1) {
        if (!suffixSpan) {
          suffixSpan = document.createElement('span');
          suffixSpan.className = 'collection-hero__page-suffix';
          m.h1El.appendChild(suffixSpan);
        }
        suffixSpan.textContent = ' - עמוד ' + page;
      } else if (suffixSpan) {
        suffixSpan.parentNode.removeChild(suffixSpan);
      }
    }
  }

  function syncPageMeta(page) {
    try {
      updateCanonicalForPage(page);
      updateMetaForPage(page);
    } catch (e) {}
  }

  function updateUrlPage(page) {
    try {
      var url = new URL(window.location.href);
      if (page <= 1) {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', String(page));
      }
      history.replaceState(history.state || {}, '', url.toString());
      syncPageMeta(page); // מסנכרן קנוניקל + טייטל + דסקריפשן + og + H1 עם העמוד הנוכחי
    } catch (e) {}
  }

  // ─── כרטיסי מוצר ─────────────────────────────────────────────────────────────

  function getProductCardFromLink(link) {
    if (!link) return null;
    return link.closest('[data-handle]');
  }

  function getHandleFromCard(card) {
    if (!card) return '';
    return card.getAttribute('data-handle') || '';
  }

  function findCardByHandle(handle) {
    if (!handle) return null;
    var escaped = cssEscape(handle);
    return document.querySelector('#product-grid [data-handle="' + escaped + '"]');
  }

  function getCardPage(card) {
    if (!card) return getCurrentPage();
    var holder = card.closest('[data-page]');
    if (holder) {
      var parsed = parseInt(holder.dataset.page || '1', 10);
      if (Number.isFinite(parsed) && parsed > 0) return parsed;
    }
    var parsedOwn = parseInt(card.dataset.page || '1', 10);
    if (Number.isFinite(parsedOwn) && parsedOwn > 0) return parsedOwn;
    return getCurrentPage();
  }

  function isProductLink(link) {
    if (!link) return false;
    return (link.getAttribute('href') || '').indexOf('/products/') !== -1;
  }

  // ─── שמירת state לחזרה ───────────────────────────────────────────────────────

  function saveReturnState(link) {
    if (!isEnabled()) return;
    if (!isProductLink(link)) return;

    var card = getProductCardFromLink(link);
    if (!card) return;

    var handle = getHandleFromCard(card);
    if (!handle) return;

    var state = {
      pending: true,
      handle: handle,
      page: getCardPage(card),
      scrollY: window.scrollY || window.pageYOffset || 0,
      savedAt: Date.now(),
      baseKey: normalizeUrlKey(window.location.href)
    };

    try {
      sessionStorage.setItem(getStorageKey(), JSON.stringify(state));
    } catch (e) {}
  }

  function isBackNavigation(evt) {
    if (evt && evt.persisted === true) return true;
    try {
      var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (navEntries && navEntries[0] && navEntries[0].type === 'back_forward') return true;
      if (performance && performance.navigation && performance.navigation.type === 2) return true;
    } catch (e) {}
    return false;
  }

  // ─── גלילה ───────────────────────────────────────────────────────────────────

  function getHeaderOffset() {
    var offset = 16;
    try {
      var header = document.querySelector('header, .header');
      if (header) {
        var style = window.getComputedStyle(header);
        if (/(fixed|sticky)/.test(style.position)) {
          offset += header.offsetHeight || 0;
        }
      }
    } catch (e) {}
    return offset;
  }

  function smoothScrollToElement(element) {
    if (!element) return;
    var top = element.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function instantScrollToElement(element) {
    if (!element) return;
    var top = element.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
  }

  // ─── תיוג פריטים ─────────────────────────────────────────────────────────────

  function tagGridItemsByPage(grid, page) {
    if (!grid) return;
    Array.prototype.forEach.call(grid.children, function (item) {
      item.dataset.page = String(page);
      var innerCard = item.querySelector('[data-handle]');
      if (innerCard) innerCard.dataset.page = String(page);
    });
  }

  function tagExistingItems(page) {
    var grid = getGrid();
    if (!grid) return;
    Array.prototype.forEach.call(grid.children, function (item) {
      if (!item.dataset.page) item.dataset.page = String(page);
      var innerCard = item.querySelector('[data-handle]');
      if (innerCard && !innerCard.dataset.page) {
        innerCard.dataset.page = String(item.dataset.page || page);
      }
    });
  }

  function retagAllItemsByCurrentDom() {
    var grid = getGrid();
    if (!grid) return;
    var fallbackPage = getCurrentPage();
    Array.prototype.forEach.call(grid.children, function (item) {
      if (!item.dataset.page) item.dataset.page = String(fallbackPage);
      var innerCard = item.querySelector('[data-handle]');
      if (innerCard && !innerCard.dataset.page) {
        innerCard.dataset.page = item.dataset.page || String(fallbackPage);
      }
    });
  }

  // ─── fetch ────────────────────────────────────────────────────────────────────

  function parseFetchedGrid(htmlText) {
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    return doc.getElementById('product-grid');
  }

  async function fetchGridForUrl(url) {
    var sectionId = getSectionId();
    if (!sectionId) throw new Error('Missing section id');

    var requestUrl = new URL(url, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);

    var response = await fetch(requestUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) throw new Error('HTTP ' + response.status);

    var htmlText = await response.text();
    var newGrid = parseFetchedGrid(htmlText);
    if (!newGrid) throw new Error('Fetched grid not found');

    return {
      newGrid: newGrid,
      requestedPage: getPageFromUrl(requestUrl.toString())
    };
  }

  async function fetchGridForPage(page) {
    var url = new URL(window.location.href);
    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }
    return fetchGridForUrl(url.toString());
  }

  function syncGridMetaFromFetchedGrid(newGrid, currentPage) {
    if (!newGrid) return;
    setNextUrl(newGrid.dataset.nextUrl || '');
    setPrevUrl(newGrid.dataset.prevUrl || '');
    setCurrentPage(currentPage);
  }

  // ─── פעולות על הגריד ─────────────────────────────────────────────────────────

  async function replaceGridWithPage(page) {
    if (!isEnabled()) return false;
    if (isReplacingGrid) return false;

    var grid = getGrid();
    if (!grid) return false;

    isReplacingGrid = true;
    showLoader(true);

    try {
      var result = await fetchGridForPage(page);
      var newGrid = result.newGrid;
      var requestedPage = result.requestedPage;

      grid.innerHTML = newGrid.innerHTML;
      syncGridMetaFromFetchedGrid(newGrid, requestedPage);
      tagGridItemsByPage(grid, requestedPage);
      updateUrlPage(requestedPage);

      document.dispatchEvent(new CustomEvent('collection:grid-replaced', {
        detail: { page: requestedPage }
      }));

      return true;
    } catch (error) {
      console.error('Replace grid failed:', error);
      return false;
    } finally {
      isReplacingGrid = false;
      showLoader(false);
    }
  }

  async function appendNextPage() {
    if (!isEnabled()) return false;
    if (isLoadingNext || isReplacingGrid) return false;

    var nextUrl = getNextUrl();
    var grid = getGrid();
    if (!grid || !nextUrl) return false;

    isLoadingNext = true;
    showLoader(true);

    try {
      var result = await fetchGridForUrl(nextUrl);
      var newGrid = result.newGrid;
      var page = result.requestedPage;
      var newItems = Array.prototype.slice.call(newGrid.children);

      if (!newItems.length) {
        setNextUrl('');
        return false;
      }

      newItems.forEach(function (item) {
        item.dataset.page = String(page);
        var card = item.querySelector('[data-handle]');
        if (card) card.dataset.page = String(page);
        grid.appendChild(item);
      });

      setCurrentPage(page);
      setNextUrl(newGrid.dataset.nextUrl || '');
      if (getPrevUrl() === '') setPrevUrl(newGrid.dataset.prevUrl || '');
      updateUrlPage(page);

      document.dispatchEvent(new CustomEvent('collection:page-appended', {
        detail: { page: page }
      }));

      return true;
    } catch (error) {
      console.error('Append next page failed:', error);
      return false;
    } finally {
      isLoadingNext = false;
      showLoader(false);
    }
  }

  async function prependPrevPage() {
    if (!isEnabled()) return false;
    if (isLoadingPrev || isReplacingGrid) return false;

    var prevUrl = getPrevUrl();
    var grid = getGrid();
    if (!grid || !prevUrl) return false;

    isLoadingPrev = true;
    setPrevBtnDisabled(true);

    try {
      var firstItem = grid.firstElementChild;
      var beforeTop = firstItem ? firstItem.getBoundingClientRect().top : 0;

      var result = await fetchGridForUrl(prevUrl);
      var newGrid = result.newGrid;
      var page = result.requestedPage;
      var newItems = Array.prototype.slice.call(newGrid.children);

      if (!newItems.length) {
        setPrevUrl('');
        removePrevButton();
        return false;
      }

      var fragment = document.createDocumentFragment();
      newItems.forEach(function (item) {
        item.dataset.page = String(page);
        var card = item.querySelector('[data-handle]');
        if (card) card.dataset.page = String(page);
        fragment.appendChild(item);
      });

      grid.insertBefore(fragment, grid.firstChild);

      if (firstItem) {
        var afterTop = firstItem.getBoundingClientRect().top;
        window.scrollBy(0, afterTop - beforeTop);
      }

      setPrevUrl(newGrid.dataset.prevUrl || '');
      if (getNextUrl() === '') setNextUrl(newGrid.dataset.nextUrl || '');
      updateUrlPage(getCurrentPage());

      if (!getPrevUrl()) removePrevButton();

      document.dispatchEvent(new CustomEvent('collection:page-prepended', {
        detail: { page: page }
      }));

      return true;
    } catch (error) {
      console.error('Prepend previous page failed:', error);
      return false;
    } finally {
      isLoadingPrev = false;
      setPrevBtnDisabled(false);
    }
  }

  // ─── חזרה מדף מוצר ───────────────────────────────────────────────────────────

  async function restoreCollectionState(evt) {
    if (!isEnabled()) return;
    if (!isBackNavigation(evt)) return;

    var raw;
    try { raw = sessionStorage.getItem(getStorageKey()); } catch (e) { raw = null; }
    if (!raw) return;

    var state = null;
    try { state = JSON.parse(raw); } catch (e) { state = null; }
    if (!state || !state.pending) return;

    if ((Date.now() - (state.savedAt || 0)) > MAX_RESTORE_AGE) {
      sessionStorage.removeItem(getStorageKey());
      return;
    }

    if (state.baseKey !== normalizeUrlKey(window.location.href)) return;

    try { sessionStorage.removeItem(getStorageKey()); } catch (e) {}

    // חוסמים onScroll כדי שלא יטעון עמוד נוסף לפני שגמרנו
    isRestoring = true;

    // מסתירים את הדף זמנית כדי למנוע את הקפיצה הוויזואלית
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);

    try {
      // שלב 1: טוענים את הדף הנכון
      var needReplace = state.page && state.page !== getCurrentPage();
      if (needReplace) {
        var replaced = await replaceGridWithPage(state.page);
        if (!replaced) return;
      } else {
        retagAllItemsByCurrentDom();
      }

      // שלב 2: כפתור עמוד קודם אם צריך
      if (getPrevUrl()) {
        injectPrevButton();
      }

      // שלב 3: גלילה למוצר – ממתינים לשני rAF כדי שה-layout יסיים לרנדר
      var scrollHandle = state.handle;
      var scrollY = state.scrollY;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var target = findCardByHandle(scrollHandle);
          if (target) {
            instantScrollToElement(target);
          } else if (typeof scrollY === 'number') {
            window.scrollTo({ top: scrollY, behavior: 'auto' });
          }
        });
      });

    } finally {
      // משחררים את החסימה אחרי רגע קצר כדי לאפשר ל-browser להתייצב
      setTimeout(function () {
        document.documentElement.style.scrollBehavior = '';
        isRestoring = false;
      }, 300);
    }
  }

  // ─── scroll ───────────────────────────────────────────────────────────────────

  function getMostVisiblePage() {
    var grid = getGrid();
    if (!grid) return getCurrentPage();

    var items = Array.prototype.slice.call(grid.children);
    if (!items.length) return getCurrentPage();

    var viewportBottom = window.innerHeight || document.documentElement.clientHeight;
    var bestPage = getCurrentPage();
    var bestVisible = -1;

    items.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var visible = Math.min(rect.bottom, viewportBottom) - Math.max(rect.top, 0);
      if (visible > bestVisible && visible > 0) {
        bestVisible = visible;
        var parsed = parseInt(item.dataset.page || '1', 10);
        if (Number.isFinite(parsed) && parsed > 0) bestPage = parsed;
      }
    });

    return bestPage;
  }

  function updateUrlByViewport() {
    if (!isEnabled()) return;
    updateUrlPage(getMostVisiblePage());
  }

  function shouldLoadMore() {
    if (!isEnabled()) return false;
    if (isRestoring) return false;
    if (isLoadingNext || isLoadingPrev || isReplacingGrid) return false;
    if (!getNextUrl()) return false;

    var grid = getGrid();
    if (!grid) return false;

    return grid.getBoundingClientRect().bottom - window.innerHeight <= getOffset();
  }

  function onScroll() {
    if (isRestoring) return;
    updateUrlByViewport();
    if (shouldLoadMore()) appendNextPage();
  }

  // ─── אתחול ───────────────────────────────────────────────────────────────────

  function bindDocumentEvents() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('#product-grid a[href*="/products/"]');
      if (!link) return;
      saveReturnState(link);
    }, true);

    window.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('pageshow', function (evt) {
      restoreCollectionState(evt);
    });

    document.addEventListener('collection:filters-rendered', function () {
      setTimeout(function () {
        retagAllItemsByCurrentDom();
        updateUrlByViewport();
        onScroll();
      }, 0);
    });
  }

  function startObserver() {
    if (observerStarted) return;

    var container = getGridContainer();
    if (!container) return;

    observerStarted = true;

    var debounceTimer = null;
    mutationObserver = new MutationObserver(function () {
      retagAllItemsByCurrentDom();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        updateUrlByViewport();
        onScroll();
      }, 50);
    });

    mutationObserver.observe(container, { childList: true, subtree: false });
  }

  function init() {
    if (!getGrid()) return;
    tagExistingItems(getCurrentPage());
    startObserver();
    updateUrlByViewport();
    onScroll();
  }

  bindDocumentEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();